import { FC } from "react";

interface FullImageCardProps {
    image: string;
    title?: string;
    subtitle?: string;
    className?: string;
    overlayOpacity?: number;
    onClick?: () => void;
    aspectRatio?: "square" | "full";
    category?: string;
}

const FullImageCard: FC<FullImageCardProps> = ({
    image,
    title,
    subtitle,
    className = "",
    overlayOpacity = 0.4,
    onClick,
    aspectRatio = "full",
    category,
}) => {
    const aspectClass = aspectRatio === "square" ? "aspect-square" : "aspect-video";

    return (
        <div
            className={`relative overflow-hidden rounded-xl cursor-pointer group ${aspectClass} ${className}`}
            onClick={onClick}
            style={aspectRatio === "square" ? { aspectRatio: "1/1" } : {}}
        >
            {/* Background Image */}
            <img
                src={image}
                alt={title || "Card image"}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />

            {/* Dark Overlay */}
            <div
                className="absolute inset-0 bg-black transition-opacity duration-300 group-hover:opacity-50"
                style={{ opacity: overlayOpacity }}
            />

            {/* Category Label */}
            {category && (
                <div className="absolute top-4 left-4 z-10">
                    <span className="inline-block px-3 py-1 text-sm font-medium text-gray-800 bg-white rounded-full shadow-md">
                        {category}
                    </span>
                </div>
            )}

            {/* Content */}
            {(title || subtitle) && (
                <div className="absolute inset-0 flex flex-col items-start justify-end p-4 sm:p-6 lg:p-8">
                    {title && (
                        <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-1 sm:mb-2 break-words max-w-full">
                            {title}
                        </h3>
                    )}
                    {subtitle && (
                        <p className="text-sm sm:text-base text-neutral-100 break-words max-w-full">
                            {subtitle}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default FullImageCard;
